import { toReduxError, GENERIC_FETCH_ERROR_MESSAGE } from '@universal/errors';
import { ofType } from 'redux-observable';
import { Observable, OperatorFunction, of } from 'rxjs';
import { catchError, groupBy, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { Action, ActionType } from 'typesafe-actions';
import { LocalDepartments } from '@appTypes/nafLocations';
import { Actions, actions } from '@redux/modules/nafLocation';
import { TypedEpic } from './types';

const fetchNafLocationsEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_NAF_LOCATIONS),
    groupBy((action) => (action as ActionType<typeof actions.getNafLocations.request>).payload.search),
    mergeMap((group$) =>
      group$.pipe(
        withLatestFrom(state$) as unknown as OperatorFunction<
          Action<any>,
          ActionType<typeof actions.getNafLocations.request>[]
        >,
        switchMap(([action]) => {
          const { search, ...params } = action.payload;
          // Filter out empty/null params and only include non-empty values
          const filteredParams = Object.fromEntries(Object.entries(params).filter(([, value]) => Boolean(value)));

          return fromApiRequest((signal) =>
            apiClient.get<{ items: LocalDepartments[]; total: number }>(ApiType.apimNafNoApi, {
              signal,
              url: ApiPaths[ApiType.apimNafNoApi].nafLocations.search(search),
              params: filteredParams,
            }),
          ).pipe(
            map((response) => {
              if (Array.isArray(response?.data?.items)) {
                return actions.getNafLocations.success({
                  ...response.data,
                  name: action.payload.search,
                  take: action.payload.take,
                  counties: action.payload.counties,
                });
              }
              return actions.getNafLocations.failure({
                error: toReduxError(undefined, GENERIC_FETCH_ERROR_MESSAGE),
                name: action.payload.search,
              });
            }),
            catchError((err) =>
              of(
                actions.getNafLocations.failure({
                  error: toReduxError(err, GENERIC_FETCH_ERROR_MESSAGE),
                  name: action.payload.search,
                }),
              ),
            ),
          );
        }),
      ),
    ),
  );

export const epics: TypedEpic[] = [fetchNafLocationsEpic];
